import type { PaymentRecord } from "../../lib/types";

interface Props {
  payments: PaymentRecord[];
}

const fmt = (n: number) =>
  n.toLocaleString("es-MX", { maximumFractionDigits: 0 });

function timeAgo(dateStr: string): string {
  const diff = Date.now() - new Date(dateStr).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 60) return `hace ${mins}m`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `hace ${hrs}h`;
  const days = Math.floor(hrs / 24);
  return `hace ${days}d`;
}

export function PaymentHistory({ payments }: Props) {
  if (payments.length === 0) {
    return (
      <div className="card p-6 text-center text-gray-500 text-sm">
        No hay pagos registrados
      </div>
    );
  }

  return (
    <div className="card overflow-hidden">
      <div className="px-4 py-3 border-b border-border">
        <h3 className="text-sm font-medium text-gray-300">
          Historial de Pagos
        </h3>
      </div>
      <div className="divide-y divide-border">
        {payments.map((p) => (
          <div key={p.id} className="px-4 py-3 flex items-center gap-3">
            <div
              className="w-2.5 h-2.5 rounded-full flex-shrink-0"
              style={{ backgroundColor: p.card_color }}
            />
            <div className="flex-1 min-w-0">
              <p className="text-sm text-gray-200">{p.card_name}</p>
              {p.note && (
                <p className="text-xs text-gray-500 truncate">{p.note}</p>
              )}
            </div>
            <div className="text-right">
              <p className="text-sm font-medium text-emerald-400">
                -${fmt(p.amount)}
              </p>
              <p className="text-[11px] text-gray-500">{timeAgo(p.paid_at)}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
